/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("regAuditFailModule", []).
controller("regAuditFailCtrl", ["$scope", "$modalInstance","userId","channelId","httpService","modalDialog","$validation","$q","$element", function($scope,$modalInstance,userId,channelId,httpService,modalDialog,$validation,$q,$element) {
    initStatus();
	initData();
    function initStatus() {
        $scope.status = {
        	
        };
        $scope.data = {
        	id : userId,
        	tagName : channelId,
        	reason:""
        }
    }
    function initData(){
    	requestData();
    }
    $scope.confirm = function() {
    	validator().then(function(){
    		var param = {reason:$scope.data.reason};
    		$modalInstance.close(param);
    	})
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
	 * [validator description] 表单校验
	 * @return {[type]} [description]
	 */
	function validator() {
		var deffer = $q.defer();
		$validation.validate($scope.regAuditFailForm).success(function() {
			deffer.resolve();
		}).error(function(result) {
			angular.invalidPosition($scope.regAuditFailForm, $element);
		});
		return deffer.promise;
	}
    function requestData(){
    	
    }
    
}]);